import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import DataTable from "react-data-table-component";
import authApiService from "../../../services/authServices";
import Modal from "../../../utils/modalUtils";
import { ThreeDots } from 'react-loader-spinner';


const ManageRegistration = () => {
  const [manageRegistrationsData, setManageRegistrationsData] = useState([]);
  const [openRegistrationsData, setOpenRegistrationsData] = useState([]);
  const [loading, setLoading] = useState(false);



  const STATUS_MAP = {
    0: "Unscheduled",
    1: "Regular Season Scheduled",
    2: "Post Season Scheduled",
    4: "Season Clear"
  };



  useEffect(() => {
    fetchManageSeason();
  }, []);



  const fetchManageSeason = async () => {
    setLoading(true);
    try {
      const response = await authApiService.get("season");
      setManageRegistrationsData(response.data?.manageRegistrationsData || []);
      setOpenRegistrationsData(response.data?.openRegistrationsData || []);


    } catch (error) {
      console.error("Error fetching leaderboard data:", error);
    } finally {
      setLoading(false); // End loading
    }
  };




  /**
   * Handles season deletion with confirmation
   * @param {Object} row - The season row to delete
   */
  const handleClearSeason = async (row) => {
    try {
      const result = await Modal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#addd1e",
        cancelButtonColor: "#b38ec1",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel"
      });

      if (result.isConfirmed) {
        try {
          const response = await authApiService.delete(`deleteSeason?id=${row.id}`);

          if (response.code === 200) {
            Modal.fire({
              icon: "success",
              title: "Deleted!",
              text: "Season deleted successfully.",
              confirmButtonText: "OK",
              confirmButtonColor: "#addd1e"
            });
          }
          fetchManageSeason();
        } catch (error) {
          console.error("Error deleting season:", error);
          Modal.fire({
            icon: "error",
            title: "Error",
            text: error.response?.data?.message || "Failed to delete Season. Please try again.",
            confirmButtonText: "OK",
            confirmButtonColor: "#addd1e"
          });
        }
      }
    } catch (error) {
      console.error("Error in handleClearSeason:", error);
    }
  };



  const columns = [
    { name: "Name", selector: (row, index) => row.name, sortable: true, width: "250px" },
    { name: "City", selector: (row) => row.cityName || "-", sortable: true, width: "180px" },
    {
      name: "-", cell: row => row.id ? (
        <Link to={`/carter/editregistrationForm?id=${row.id}`} className="text-primary">
          Edit
        </Link>
      ) : (
        <span className="text-muted" style={{ pointerEvents: "none", opacity: 0.5 }}>
          Edit
        </span>
      )
    },
    { name: "Name", selector: (row) => STATUS_MAP[row.statusMessageID], sortable: true },
    // { name: "-", cell: row => row.id ? (<Link to={`/carter/viewSeason?id=${row.id}`}>view schedule</Link>) : "-" },
    {
      name: "-",
      cell: row => {
        if (!row.id) return "-";

        if (row.statusMessageID === 2 || row.statusMessageID === 1) {
          return <Link to={`/carter/viewSeason?id=${row.id}`}>view schedule</Link>;
        } else {
          return "";
        }

        return "-";
      }
    },
    {
      name: "-",
      cell: row => {
        if (!row.id) return "-";

        if (row.statusMessageID === 0) {
          return <Link to={`/carter/scheduleSeason?id=${row.id}`}>Schedule Regular Season</Link>;
        } else if (row.statusMessageID === 1) {
          return <Link to={`/carter/postscheduleSeason?id=${row.id}`} state={{ name: row.name }}>Schedule Post Season</Link>;
        } else if (row.statusMessageID === 2) {
          return ""; // or return null;
        }

        return "-";
      }
    },
    {
      name: "-",
      cell: row => (
        <Link to="#" onClick={(e) => { e.preventDefault(); handleClearSeason(row); }}>
          Clear Season
        </Link>
      )
    },
  ];

  const openColumns = [
    { name: "Name", selector: (row) => row.name, sortable: true, width: "250px" },
    { name: "City", selector: (row) => row.cityName || "-", sortable: true, width: "180px" },
    {
      name: "-",
      cell: row => row.id ? (
        <Link to={`/carter/editregistrationForm?id=${row.id}`} className="text-primary">
          Edit
        </Link>
      ) : (
        <span className="text-muted" style={{ pointerEvents: "none", opacity: 0.5 }}>
          Edit
        </span>
      )
    },
  ];

  const customStyles = {
    table: {
      style: {
        border: "1px solid #ddd",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#40444d", // Black header row
        color: "#ffffff", // White text for header
      },
    },
    rows: {
      style: {
        "&:nth-of-type(odd)": {
          backgroundColor: "#dedfdd",

        },
        "&:nth-of-type(even)": {
          backgroundColor: "#ffffff",
        },
      },
    },
  };

  return (
    <>
      <div id="page-admin-users" className="page-admin">
        <div>
          {loading ? (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "300px" }}>
              <ThreeDots
                height="80"
                width="80"
                radius="9"
                color="#4fa94d"
                ariaLabel="three-dots-loading"
                visible={true}
              />
            </div>
          ) : (
            <DataTable
              columns={columns}
              data={manageRegistrationsData}
              pagination
              highlightOnHover
              striped
              customStyles={customStyles}
            />
          )}
        </div>

        <div className="mt-10">Still Open for Registration</div>
        <div>
          {loading ? (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "300px" }}>
              <ThreeDots
                height="80"
                width="80"
                radius="9"
                color="#4fa94d"
                ariaLabel="three-dots-loading"
                visible={true}
              />
            </div>
          ) : (
            <DataTable
              columns={openColumns}
              data={openRegistrationsData}
              pagination
              highlightOnHover
              striped
              customStyles={customStyles}
            />
          )}

        </div>

        <div>
          <Link
            to="/carter/registrationForm"
            className="mb-5 mt-2"
            style={{
              backgroundColor: "#9cb23b",
              borderColor: "#9cb23b",
              color: "#fff",
              padding: "10px 20px",
              borderRadius: "15px",
              fontSize: "16px",
              fontWeight: "bold",
              textAlign: "center",
              display: "inline-block",
              textDecoration: "none"
            }}
          >
            Add New Season

          </Link>
        </div>

      </div>
    </>
  )
}

export default ManageRegistration;
